/** Soft curved edge for blue sections, matching the homepage dividers. Place inside a relative, overflow-hidden section. */
const Curve = ({ position, fill = "hsl(var(--background))" }: { position: "top" | "bottom"; fill?: string }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 1440 40"
    preserveAspectRatio="none"
    className={`absolute inset-x-0 z-[2] block h-6 w-full md:h-10 pointer-events-none ${position === "top" ? "top-0" : "bottom-0"}`}
  >
    <path d={position === "top" ? "M0,0 L1440,0 L1440,4 Q720,64 0,4 Z" : "M0,40 L1440,40 L1440,36 Q720,-24 0,36 Z"} fill={fill} />
  </svg>
);
export default Curve;
